import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="About-Me">
          <h3>Welcome to Kevin Bunn's official website! [WIP]</h3>
          <h6>--- Creating unique web experiences since 2019 under aliases Platonic, Pseudonian and Pseudo-Corp ---</h6>

          <p>I am an undergraduate attending Massachusetts Institute of Technology (MIT), majoring in Computer Science and Economics. I specialize in UI and UX design as well as functional data visualization.</p>
        </div>
        <h2>
          Here's some projects I've worked on.
        </h2>
        <a
          className="App-link"
          href="https://pseudo-corp.github.io/SynergismOfficial/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Synergism V2.8.2 (2019-)
        </a>

        <a
          className="App-link"
          href='https://pseudonian.github.io/Click-Ideas/'
          target="_blank"
          rel="noopener noreferrer"
        >
          Click Ideas (2019)
        </a>

        <a>
          UPB (2022-) INDEV!
        </a>

        <div>
          <p>Come join my community! <a className="App-link" 
                                        href='https://discord.gg/synergism'
                                        target="_blank"
                                        rel="noopener noreferrer">Discord</a></p>
        </div>
      </header>
    </div>
  );
}

export default App;
